import 'antd/dist/antd.variable.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';
import { RouterProvider } from 'react-router-dom';

import { initI18Next } from '../i18n';
import router from '../navigation/Router';
import RouterPublic from '../navigation/RouterPublic';
import reportWebVitals from '../services/reportWebVitals';
import Config from './config';

const tagManagerArgs = {
  gtmId: Config.REACT_APP_GTM_ID || '',
};

TagManager.initialize(tagManagerArgs);

initI18Next();

if (document.getElementById('root')) {
  ReactDOM.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>,
    document.getElementById('root')
  );
}

if (document.getElementById('public')) {
  ReactDOM.render(
    <React.StrictMode>
      <RouterPublic />
    </React.StrictMode>,
    document.getElementById('public')
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
